import { Tracking } from './../../providers/tracking';
import { ModelMetier } from './../../providers/model-metier';
import { AuthData } from './../../providers/auth-data';
import { MyFirebase } from './../../providers/my-firebase';
import { ElesPage } from './../eles/eles';
import { CloudPage } from './../cloud/cloud';
import { Component } from '@angular/core';
import { ActionSheetController, AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';


/**
 * Clouds page
 */
@IonicPage()
@Component({
  selector: 'page-clouds',
  templateUrl: 'clouds.html',
})
export class CloudsPage extends ElesPage {

  
  // Mode edition ou selection
  edit : boolean; 
 

  
  // Filter
  doFilter(ele, index, array) :boolean {

    // if (this.doFilterRegExp == null) return true;
    // if ( ele.value.name == null) return true;
    try { 

      // Affiche les disable pour admin
      if (ele.value.disabled) {
        if (!this.authData.isUserAdmin() )
          return false;
      } 

      // if (this.doFilterRegExp instanceof String) return ele.value.name.search( this.doFilterRegExp ) != -1;
      return this.doFilterRegExp.test(ele.value.name);

    } catch(e) {  }

    return true;
  }



  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController,
              public authData: AuthData, public tracking : Tracking,
              public myFirebase : MyFirebase, public modelMetier : ModelMetier) {

    super(navCtrl, navParams, alertCtrl, actionSheetCtrl, myFirebase );

    // Ref Firebase list  
    this.elesRef = ModelMetier.getCloudsElesRef();          // firebase.database().ref('/clouds');
    this.childrenRef = ModelMetier.getCloudsChildrenRef();  // firebase.database().ref('/clouds/orders');

    // Add page
    this.addPage = CloudPage;

    // Update page
    this.updatePage = CloudPage;


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CloudsPage');
    super.ionViewDidLoad();

    this.onSearch('');

  }
 
  ionViewWillUnload() {
    console.log('ionViewWillUnload CloudsPage');
    super.ionViewWillUnload();
  }

  ionViewDidEnter() {
    this.tracking.view(this);
  }


  addOrUpdate(eleId, ele) : firebase.Promise<any> {

    return this.myList.addOrUpdate(eleId, ele);
  }

  onEdit() {
    this.edit = !this.edit;
    if (this.edit)  this.tracking.view('CloudsPage Edit');
    else  this.tracking.view('CloudsPage');
  }


  onSelect(key, ele) {
    
    // Si edit, onUpdate
    if (this.edit) return this.onUpdate(key, ele);
    

    let homePage = <any>this.parentPage;

    // homePage.cloud = ele;
    homePage.cloudId = key;
    homePage.cloud = this.myList.getEleId(key);
    this.navCtrl.pop();

    this.tracking.event('Click', 'Select cloud', ele.name, 0, false);

  }
  

  onUpdate(key, ele) {
    super.onUpdate(key, ele);
  }

}




// WEBPACK FOOTER //
// ./src/pages/clouds/clouds.ts